import { IconCheck, IconEdit } from '@tabler/icons-react';
import { type IImpugnatedQuestion } from '../../types/impugnatedquestion';
import { format } from 'date-fns';
import clsx from 'clsx';

interface Params {
  onAccept: (q: IImpugnatedQuestion) => void
  onReject: (q: IImpugnatedQuestion) => void
}

export const getColumns = ({ onAccept, onReject }: Params) => [
  {
    title: 'Pregunta',
    dataIndex: ['question', 'title'],
    key: 'question_title'
  },
  {
    title: 'Usuario',
    dataIndex: ['user', 'name'],
    key: 'user_name'
  },
  {
    title: 'Motivo',
    dataIndex: 'reason',
    key: 'reason'
  },
  {
    title: 'Fecha',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: (val: Date) => format(new Date(val), 'dd/MM/yyyy')
  },
  {
    title: 'Acciones',
    dataIndex: '',
    key: 'actions',
    width: 120,
    render: (q: IImpugnatedQuestion) => (
      <div className="flex items-center gap-2">
        <button
          onClick={() => { onAccept(q); }}
          className={clsx(
            'p-2 rounded-lg transition-all duration-300',
            'text-blue-600 hover:bg-blue-50',
            'dark:text-blue-400 dark:hover:bg-blue-900/20'
          )}
          title="Editar pregunta"
        >
          <IconEdit size={18} strokeWidth={2} />
        </button>
        <button
          onClick={() => { onReject(q); }}
          className={clsx(
            'p-2 rounded-lg transition-all duration-300',
            'text-green-600 hover:bg-green-50',
            'dark:text-green-400 dark:hover:bg-green-900/20'
          )}
          title="Resolver impugnación"
        >
          <IconCheck size={18} strokeWidth={2} />
        </button>
      </div>
    )
  }
];
